<template>
  <label
    v-if="
      ['version', 'invoice_ids', 'ranchecker_version', 'project_ids'].includes(
        id
      )
    "
    class="form-field"
  >
    <span class="label">{{ field.label }}</span>
    <input
      class="control"
      type="text"
      :placeholder="field.placeholder"
      :value="value"
      @input="(e) => $emit('input', e.target.value)"
    />
  </label>
  <label
    v-else-if="
      ['faulty_software', 'quote_type', 'credit_type', 'project_step'].includes(
        id
      )
    "
    class="form-field"
  >
    <span class="label">{{ field.label }}</span>
    <select
      class="control"
      @input="(e) => $emit('input', e.target.value)"
      :value="value"
    >
      <option disabled value="">-----</option>
      <option v-for="(text, i) in field.options" :key="i" :value="i">
        {{ text }}
      </option>
    </select>
  </label>
</template>
<script>
export default {
  props: ["id", "fields", "value"],
  computed: {
    field() {
      return this.fields[this.id];
    },
  },
};
</script>
